// src/component/Buttons.jsx
export function ElevatedButton({ children, disabled, className = "", ...props }) {
  return (
    <button
      disabled={disabled}
      className={`
        px-4 py-3 rounded-lg whitespace-nowrap
        bg-bg-successBold text-white shadow-md
        hover:bg-bg-infoBold
        transition-[transform,background-color,color] duration-150 ease-out active:scale-[0.97] disabled:active:scale-100 motion-reduce:active:scale-100
        disabled:bg-gray-300 disabled:text-gray-600 disabled:cursor-not-allowed disabled:hover:bg-gray-300
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}

export function TextButton({ children, disabled, className = "", ...props }) {
  return (
    <button
      disabled={disabled}
      className={`
        inline-flex items-center justify-center whitespace-nowrap
        px-4 py-3 rounded-lg
        text-body-lg
        bg-transparent text-text-interactive-primary
        hover:bg-bg-secondary hover:text-text-interactive-primaryHovered
        active:text-text-interactive-primaryPressed
        disabled:text-text-disabled disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-text-disabled
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}

export function OutlinedButton({ children, disabled, className = "", ...props }) {
  return (
    // hover 는 «면이 차는» 상태라 글자는 반전(흰색)이어야 한다.
    // text-interactive-primary-hovered 는 bg 와 같은 #163627 이라 글자가 사라진다
    // — 원래 그렇게 적혀 있었지만 클래스 이름이 죽어 있어 아무도 못 봤다.
    <button
      disabled={disabled}
      className={`
        inline-flex items-center justify-center
        px-4 py-3 rounded-lg
        bg-white text-text-interactive-primary
        border border-border-interactive-primary
        hover:bg-bg-interactive-primaryHovered hover:text-text-interactive-inversed hover:border-border-interactive-primaryHovered
        active:bg-bg-interactive-selectedPressed
        disabled:bg-bg-disabled disabled:text-text-disabled disabled:border-border-disabled disabled:cursor-not-allowed
        disabled:hover:bg-bg-disabled
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}

export function IconButton({
  iconSrc,
  iconAlt = "",
  size = 40,
  iconSize = 32,
  disabled,
  className = "",
  imgClassName = "",
  rounded = "lg",
  ...props
}) {
  const roundedBtn = rounded === "full" ? "rounded-full" : "rounded-lg";
  const roundedImg = rounded === "full" ? "rounded-full" : "";

  return (
    <button
      disabled={disabled}
      aria-label={iconAlt || "icon button"}
      className={`
        inline-flex items-center justify-center
        ${roundedBtn}
        overflow-hidden
        bg-bg-primary
        hover:bg-bg-secondary
        active:bg-bg-interactive-selectedPressed
        disabled:bg-bg-disabled disabled:cursor-not-allowed
        ${className}
      `}
      style={{ width: size, height: size }}
      {...props}
    >
      <img
        src={iconSrc}
        alt={iconAlt}
        className={`
          block w-full h-full object-cover
          ${roundedImg}
          ${disabled ? "opacity-60" : ""}
          ${imgClassName}
        `}
        draggable={false}
      />
    </button>
  );
}
